import { render, staticRenderFns } from "./X-modale-commentaire-livraison.vue?vue&type=template&id=689819ac"
import script from "./X-modale-commentaire-livraison.vue?vue&type=script&lang=js"
export * from "./X-modale-commentaire-livraison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('689819ac')) {
      api.createRecord('689819ac', component.options)
    } else {
      api.reload('689819ac', component.options)
    }
    module.hot.accept("./X-modale-commentaire-livraison.vue?vue&type=template&id=689819ac", function () {
      api.rerender('689819ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/livraison/X-modale-commentaire-livraison.vue"
export default component.exports